import { AlertTriangle, Inbox, LoaderCircle, RefreshCw, ShieldAlert } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button, ButtonLink, Card } from './ui';

interface PageLoaderProps {
  label?: string;
}

export function PageLoader({ label = 'Bilgileriniz hazırlanıyor…' }: PageLoaderProps) {
  return (
    <div aria-live="polite" className="state state--loading" role="status">
      <LoaderCircle aria-hidden="true" className="spin" size={30} />
      <p>{label}</p>
    </div>
  );
}

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({
  title = 'Bir şey yolunda gitmedi',
  message = 'Bilgileriniz şu anda alınamıyor. Lütfen biraz sonra tekrar deneyin.',
  onRetry,
}: ErrorStateProps) {
  return (
    <Card aria-live="assertive" className="state state--error" role="alert">
      <AlertTriangle aria-hidden="true" size={30} />
      <h2>{title}</h2>
      <p>{message}</p>
      {onRetry ? (
        <Button onClick={onRetry} type="button" variant="secondary">
          <RefreshCw aria-hidden="true" size={17} /> Yeniden dene
        </Button>
      ) : null}
    </Card>
  );
}

interface EmptyStateProps {
  title: string;
  message: string;
  action?: ReactNode;
}

export function EmptyState({ title, message, action }: EmptyStateProps) {
  return (
    <Card className="state state--empty">
      <Inbox aria-hidden="true" size={32} />
      <h2>{title}</h2>
      <p>{message}</p>
      {action}
    </Card>
  );
}

export function AccessDeniedState({ admin = false }: { admin?: boolean }) {
  return (
    <main className="standalone-state">
      <Card className="state state--error">
        <ShieldAlert aria-hidden="true" size={34} />
        <p className="eyebrow">Güvenli alan</p>
        <h1>{admin ? 'Yönetici yetkisi gerekli' : 'Bu aboneliğe erişemezsiniz'}</h1>
        <p>
          {admin
            ? 'Bu sayfa yalnızca doğrulanmış yönetici hesabına atanmış admin yetkisiyle açılır.'
            : 'Abonelikler yalnızca ait oldukları Tropikal Akdeniz hesabından yönetilebilir.'}
        </p>
        <ButtonLink to={admin ? '/subscriptions' : '/subscriptions'} variant="secondary">
          Aboneliklerime dön
        </ButtonLink>
      </Card>
    </main>
  );
}
